import React from 'react';
import HamsterGame from './components/HamsterGame';

function App() {
  return <HamsterGame />;
}

export default App;